import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { LoggerLevel } from '../enums/logger-level.enum';
import { LoggerType } from '../enums/logger-type.enum';

/**
 * Service for logging
 */
@Injectable({
	providedIn: 'root'
})
export class LoggerService {
	// =======================================================================================================================================
	// Properties
	// =======================================================================================================================================

	/**
	 * Logger configuration
	 */
	protected config: {
		level: LoggerLevel;
	};

	// =======================================================================================================================================
	// Constructor
	// =======================================================================================================================================

	/**
	 * Constructor
	 */
	constructor(private configService: ConfigService) {
		this.initConfig();
	}

	/**
	 * (Re)Init service configuration
	 */
	public initConfig() {
		const defaultConfig = {
			level: LoggerLevel.TRACE
		};

		if (this.configService.config && this.configService.config.logging) {
			this.config = _.mergeWith(defaultConfig, this.configService.config.logging);
		}
	}

	// =======================================================================================================================================
	// Logging methods
	// =======================================================================================================================================

	/**
	 * Debug
	 */
	public get debug() {
		return this.logger(LoggerType.DEBUG, LoggerLevel.DEBUG);
	}

	/**
	 * Info
	 */
	public get info() {
		return this.logger(LoggerType.INFO, LoggerLevel.INFO);
	}

	/**
	 * Log
	 */
	public get log() {
		return this.logger(LoggerType.LOG, LoggerLevel.LOG);
	}

	/**
	 * Warn
	 */
	public get warn() {
		return this.logger(LoggerType.WARN, LoggerLevel.WARN);
	}

	/**
	 * Error
	 */
	public get error() {
		return this.logger(LoggerType.ERROR, LoggerLevel.ERROR);
	}

	/**
	 * Table
	 */
	public get table() {
		return this.logger(LoggerType.TABLE, LoggerLevel.INFO);
	}

	// =======================================================================================================================================
	// Helper methods
	// =======================================================================================================================================

	/**
	 * Get logger
	 *
	 * @param type - Logger type
	 * @param level - Logger level
	 */
	protected logger(type: LoggerType = LoggerType.LOG, level: LoggerLevel = LoggerLevel.TRACE) {
		if (this.config && level >= this.config.level) {
			return console[type] ? console[type] : console[LoggerType.LOG] ? console[LoggerType.LOG] : () => {};
		} else {
			return () => {};
		}
	}
}
